export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/afters/resources/mounted.js